import { lazyLoadOnRender } from '@ms/yammer-libs-lazy';
import type { ComponentType } from 'react';

const ThirdPartyCookiesDisabled = () =>
  import(/* webpackChunkName: "4-feat-thirdpartycookies" */ './ThirdPartyCookiesDisabled');

const LoadableThirdPartyCookiesDisabled: ComponentType = lazyLoadOnRender({ loader: ThirdPartyCookiesDisabled });
export default LoadableThirdPartyCookiesDisabled;
